/* Display-only currency conversion. Never writes Shopify cart, checkout, prices, or markets. */
(() => {
  'use strict';
  if (window.SosoCurrency) return;
  const firstSelect = document.querySelector('[data-soso-currency-select]');
  if (!firstSelect) return;
  const base = firstSelect.dataset.base || 'QAR';
  const locale = firstSelect.dataset.locale || document.documentElement.lang || 'en';
  const rates = window.Currency && window.Currency.rates;
  const countryCurrencies = {"AC":"SHP","AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"EUR","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"XAF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUP","CV":"CVE","CW":"XCG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DG":"USD","DJ":"DJF","DK":"DKK","DM":"XCD","DO":"DOP","DZ":"DZD","EA":"EUR","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","EU":"EUR","FI":"EUR","FJ":"FJD","FK":"FKP","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GS":"GBP","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HM":"AUD","HN":"HNL","HR":"EUR","HT":"HTG","HU":"HUF","IC":"EUR","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LA":"LAK","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"ZAR","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","MK":"MKD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"XOF","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"PAB","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PS":"ILS","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLE","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"USD","SX":"XCG","SY":"SYP","SZ":"SZL","TA":"GBP","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"WST","XK":"EUR","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWG"};
  const isRate = code => typeof code === 'string' && /^[A-Z]{3}$/.test(code) && Number.isFinite(rates?.[code]) && rates[code] > 0;
  const allowed = ['QAR', 'SAR', 'AED', 'KWD', 'BHD', 'OMR', 'USD', 'EUR', 'GBP', 'JPY', 'CAD', 'AUD', 'CHF'];
  const isArabic = locale.toLowerCase().startsWith('ar');
  // Localized text fallbacks; official SAR/AED artwork remains unchanged.
  const symbols = {
    QAR: isArabic ? 'ر.ق' : 'QAR', SAR: isArabic ? 'ر.س' : 'SAR',
    AED: isArabic ? 'د.إ' : 'AED', KWD: isArabic ? 'د.ك' : 'KWD',
    BHD: isArabic ? 'د.ب' : 'BHD', OMR: isArabic ? 'ر.ع' : 'OMR',
    USD: 'US$', EUR: '€', GBP: '£', JPY: '¥', CAD: 'CA$', AUD: 'A$',
    CHF: isArabic ? 'ف.س' : 'CHF'
  };
  const names = { SAR: isArabic ? 'ريال سعودي' : 'Saudi riyals', AED: isArabic ? 'درهم إماراتي' : 'UAE dirhams' };
  const artwork = { SAR: firstSelect.dataset.sosoSarSymbol, AED: firstSelect.dataset.sosoAedSymbol };
  const rendered = new WeakMap();
  function symbolNode(currency) {
    const wrapper = document.createElement('span');
    wrapper.className = 'soso-currency-artwork';
    wrapper.setAttribute('aria-hidden', 'true');
    const image = document.createElement('img');
    image.src = artwork[currency];
    image.alt = '';
    image.width = currency === 'AED' ? 345 : 533;
    image.height = currency === 'AED' ? 300 : 595;
    const fallback = document.createElement('span');
    fallback.className = 'soso-currency-fallback';
    fallback.textContent = symbols[currency] || currency;
    image.addEventListener('load', () => wrapper.classList.add('is-loaded'));
    image.addEventListener('error', () => wrapper.classList.remove('is-loaded'));
    wrapper.append(image, fallback);
    return wrapper;
  }
  function renderMoney(node, value, source) {
    const official = artwork[selected] && (selected === source || (isRate(selected) && isRate(source)));
    if (!official) {
      rendered.delete(node);
      node.classList.remove('soso-money-official');
      if (node.textContent !== value) node.textContent = value;
      return;
    }
    const signature = selected + '|' + source + '|' + value;
    if (rendered.get(node) === signature) return;
    const number = value.replace('\u2068' + symbols[selected] + '\u2069', '').replace(/[\u061c\u200e\u200f\u2066-\u2069]/g, '').trim();
    const label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = names[selected] + ' ';
    const amount = document.createElement('span');
    amount.dir = 'ltr';
    amount.textContent = number;
    node.classList.add('soso-money-official');
    node.replaceChildren(label, symbolNode(selected), amount);
    rendered.set(node, signature);
  }
  const minorUnits = { JPY: 0, KWD: 3, BHD: 3, OMR: 3 };
  const currencies = allowed.filter(isRate);
  const storageKey = 'soso-display-currency-v1';
  const cacheKey = 'soso-detected-currency-v2';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch (_) {} };
  const valid = code => currencies.includes(code);
  const saved = read('localStorage', storageKey);
  let manual = valid(saved);
  let selected = manual ? saved : base;
  const formatters = new Map();
  function format(cents, currency = selected, source = base) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return null;
    if (currency !== source && (!isRate(currency) || !isRate(source))) currency = source;
    const converted = currency === source ? amount / 100 : amount / 100 * rates[source] / rates[currency];
    if (!Number.isFinite(converted)) return null;
    try {
      if (!formatters.has(currency)) formatters.set(currency, new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'symbol' }));
      return formatters.get(currency).formatToParts(converted).map(part => part.type === 'currency' ? '\u2068' + (symbols[currency] || part.value) + '\u2069' : part.value).join('');
    } catch (_) { return '\u2068' + (symbols[currency] || currency) + '\u2069\u00a0' + converted.toFixed(minorUnits[currency] ?? 2); }
  }
  function refresh(root = document) {
    const nodes = [...root.querySelectorAll('[data-soso-money]')];
    if (root.matches?.('[data-soso-money]')) nodes.unshift(root);
    nodes.forEach(node => {
      const value = format(node.dataset.sosoMoney, selected, node.dataset.sosoBase || base);
      if (value !== null) renderMoney(node, value, node.dataset.sosoBase || base);
    });
  }
  function setupSelectors() {
    document.querySelectorAll('[data-soso-currency-select]').forEach(select => {
      if (!select.dataset.ready && isRate(base)) {
        select.replaceChildren(...currencies.map(code => {
          const option = document.createElement('option'); option.value = code; option.textContent = '\u2068' + (symbols[code] || code) + '\u2069'; return option;
        }));
        select.dataset.ready = 'true';
        select.closest('[data-soso-currency-control]').hidden = false;
      }
      select.value = selected;
      const display = select.closest('[data-soso-currency-control]').querySelector('[data-soso-currency-symbol]');
      if (display) {
        if (artwork[selected]) display.replaceChildren(symbolNode(selected));
        else display.textContent = symbols[selected] || selected;
      }
    });
  }
  function choose(currency) {
    if (!valid(currency)) return;
    selected = currency;
    setupSelectors();
    refresh();
  }
  window.SosoCurrency = { format, refresh, get currency() { return selected; }, base };
  setupSelectors();
  refresh();
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-soso-currency-select]')) return;
    manual = true;
    choose(event.target.value);
    write('localStorage', storageKey, selected);
  });
  document.addEventListener('shopify:section:load', () => { setupSelectors(); refresh(); });
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-soso-money'] });
  if (manual || !isRate(base)) return;
  const cached = read('sessionStorage', cacheKey);
  if (valid(cached)) { choose(cached); return; }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { signal: controller.signal, credentials: 'same-origin' })
    .then(response => response.ok ? response.json() : Promise.reject(new Error('Location unavailable')))
    .then(data => {
      const code = data.detected_values?.country?.handle;
      const detected = countryCurrencies[code];
      const currency = valid(detected) ? detected : base;
      if (valid(currency)) { write('sessionStorage', cacheKey, currency); if (!manual) choose(currency); }
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
